import { useQuery } from '@tanstack/react-query';
import { scenarioApi, scenarioKeys } from '../api';

export function useScenarios(teamId?: string, { enabled = true }: { enabled?: boolean } = {}) {
  return useQuery({
    queryKey: scenarioKeys.list(teamId),
    queryFn: () => scenarioApi.fetchScenarios(teamId),
    enabled,
    staleTime: 30_000,
  });
}

export function useScenarioDetail(id: string | undefined) {
  return useQuery({
    queryKey: scenarioKeys.detail(id as string),
    queryFn: () => scenarioApi.fetchDetail(id as string),
    enabled: !!id,
    staleTime: 30_000,
  });
}
